import React, { createContext, useContext, useReducer } from 'react';

const AssessmentContext = createContext();

const initialState = {
  userInfo: {
    name: '',
    email: '',
    functionalRole: '',
    customRole: '',
    orgCode: '',
    userProvidedCode: false
  },
  responses: {},
  aboutYou: {
    companyName: '',
    favoriteElements: '',
    interestedAreas: [],
    productServices: '',
    idealClient: '',
    businessLifecycle: '',
    companySize: '',
    technologyAdoption: '',
    biggestObstacles: '',
    motivationLevel: 5,
  },
  currentStep: 0,
  isComplete: false,
};

function assessmentReducer(state, action) {
  switch (action.type) {
    case 'SET_USER_INFO':
      return { ...state, userInfo: { ...state.userInfo, ...action.payload } };
    case 'SET_RESPONSE':
      return { ...state, responses: { ...state.responses, [action.payload.questionId]: action.payload.value } };
    case 'SET_ABOUT_YOU':
      return { ...state, aboutYou: { ...state.aboutYou, ...action.payload } };
    case 'SET_CURRENT_STEP':
      return { ...state, currentStep: action.payload };
    case 'COMPLETE_ASSESSMENT':
      return { ...state, isComplete: true };
    case 'RESET_ASSESSMENT':
      return initialState;
    default:
      return state;
  }
}

export function AssessmentProvider({ children }) {
  const [state, dispatch] = useReducer(assessmentReducer, initialState);
  return (
    <AssessmentContext.Provider value={{ state, dispatch }}>
      {children}
    </AssessmentContext.Provider>
  );
}

export function useAssessment() {
  const context = useContext(AssessmentContext);
  if (!context) {
    throw new Error('useAssessment must be used within an AssessmentProvider');
  }
  return context;
}